import styled from "styled-components";
import { Button } from "reactstrap";

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const BootstrapButton = styled(Button)`
  position: relative;
  flex-grow: 1;
  width: calc((100% / 3) - 5px * 2);
  margin: 5px;
`;
